import React from 'react';
import { TextDynamic, FlexRow, FlexCol, BodyTextSmall } from '@minecraft.atoms';
import { Carousel } from '@minecraft.molecules';
import { useTranslation } from '@blocs.i18n';
import { appConfig } from '@minecraft.app-config';
import { WindowWidthContext } from '@minecraft.utils';

type CommercialCardProps = {
  title: string;
  company: string;
  year: string;
  imgSrc: string;
};

export const COMMERCIALS: CommercialCardProps[] = [
  { title: 'MSC Cruises', company: 'Background Casting', year: '2025', imgSrc: 'msc-cruises.png' },
  {
    title: 'Little Caesars Pizza - Whoa!',
    company: 'Ross Lacy Casting',
    year: '2025',
    imgSrc: 'little-caesars-pizza.png',
  },
  { title: `Reeses - Don't Eat Lava`, company: 'Clockwork Casting', year: '2025', imgSrc: 'reeses.png' },
  { title: 'You Got Cirkul', company: 'House of Talent', year: '2025', imgSrc: 'cirkul.png' },
  { title: 'Pizza Hut', company: 'Sparkling Casting', year: '2025', imgSrc: 'pizza-hut.png' },
];

const WrapperComponent = ({ children }) => {
  const isMobile = WindowWidthContext.useIsMobile();

  if (isMobile) {
    return (
      <Carousel
        settings={{
          dots: false,
          infinite: true,
          speed: 5000,
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 0,
          cssEase: 'linear',
          pauseOnHover: false,
          pauseOnFocus: false,
          arrows: false,
        }}
      >
        {children}
      </Carousel>
    );
  }

  return <FlexRow gap="7">{children}</FlexRow>;
};

const Cards = () => {
  return (
    <WrapperComponent>
      {COMMERCIALS.map(({ title, company, imgSrc, year }) => (
        <FlexCol key={imgSrc} w="min">
          <img
            src={`${appConfig.cdnRoot}/images/static/${imgSrc}`}
            alt="commercial"
            className="cn_w-40 cn_atom_rounded-md"
          />
          <FlexRow w="full" justifyContent="space-between" alignItems="start">
            <FlexCol w="min">
              <BodyTextSmall fontWeight="medium" textWrap="balance">
                {title}
              </BodyTextSmall>
              <BodyTextSmall>{company}</BodyTextSmall>
            </FlexCol>
            <BodyTextSmall>{year}</BodyTextSmall>
          </FlexRow>
        </FlexCol>
      ))}
    </WrapperComponent>
  );
};

export const CommercialCards = React.memo(() => {
  const { t } = useTranslation();

  return (
    <FlexCol justifyContent="center" alignItems="center" gap="3" mb="12" mdProps={{ gap: '4' }}>
      <TextDynamic align="center" fontWeight="semibold" color="disabled" as="h3" fontSize="bodyLarge">
        {t('common:paywall.checkout.commercialCardsTitle')}
      </TextDynamic>
      <Cards />
    </FlexCol>
  );
});
